import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'kamonaTimeFormat',
})
export class KamonaTimeFormatPipe implements PipeTransform {
	transform(time?: number | string): string | number {
		if (time) {
			return Number(time) < 10 ? `0${time}` : time;
		}
		return '00';
	}
}
